import * as React from 'react';

import classnames from 'classnames';

import {StarIcon} from 'shells/icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {FormSchemaProperty} from '../../../../../core/nutshell-fields/types';

import styles from './field-styles.module.css';

type DisplayType = 'dropdown' | 'radio' | 'checkbox';

type Props = {
    fieldSchema: FormSchemaProperty;
    displayType?: DisplayType;
    style: {
        color: string;
        fontSize: string;
    };
    defaultValues?: string[];
};

export function EnumOptions(props: Props) {
    // @ts-expect-error
    const getStyleName = (displayType) => {
        switch (displayType) {
            case 'dropdown':
                return styles['dropdown-option'];
            case 'radio':
                return styles['radio-option'];
            case 'checkbox':
                return styles['checkbox-option'];
        }
    };

    const optionStyle = {
        width: props.style.fontSize,
        height: props.style.fontSize,
    } as const;

    return (
        <div style={props.style}>
            <StackLegacy spacing={8}>
                {props.fieldSchema.options.map((value) => {
                    const isPreselected =
                        props.defaultValues && props.defaultValues.includes(value.id);

                    return (
                        <React.Fragment key={value.id}>
                            <div className={styles['option-container']}>
                                {props.displayType === 'radio' && (
                                    <div
                                        style={optionStyle}
                                        className={classnames(styles.radio, {
                                            [styles['radio-preselected']]: isPreselected,
                                        })}
                                    ></div>
                                )}

                                {props.displayType === 'checkbox' && (
                                    <div
                                        style={optionStyle}
                                        className={classnames(styles.checkbox, {
                                            [styles['checkbox-preselected']]: isPreselected,
                                        })}
                                    ></div>
                                )}

                                <div className={getStyleName(props.displayType)}>
                                    {value.name}
                                    {props.displayType === 'dropdown' && isPreselected && (
                                        <>
                                            <StarIcon className={styles['preselected-icon']} />
                                            Preselected
                                        </>
                                    )}
                                </div>
                            </div>
                            {isPreselected && props.displayType !== 'dropdown' && (
                                <div className='flex ml-16 pt-4  align-center'>
                                    <StarIcon className={styles['preselected-icon']} />
                                    Preselected
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </StackLegacy>
        </div>
    );
}
